import styled from 'styled-components';
import { ArrowForward } from '@mui/icons-material';

import colors from '../../../../../styles/colors';

const SelectorRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 15px;
  margin-bottom: 10px;
`;

const SelectorField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 260px;
`;

const FieldLabel = styled.span`
  font-size: 12px;
  color: ${colors.shades.secondary8};
`;

const DirectionIcon = styled(ArrowForward)`
  color: ${colors.shades.secondary8};
  margin-bottom: 12px;
`;

const Warning = styled.span`
  font-size: 12px;
  color: ${colors.shades.danger3};
  margin-bottom: 10px;
`;

export {
  SelectorRow,
  SelectorField,
  FieldLabel,
  DirectionIcon,
  Warning,
};
